module.exports = __webpack_public_path__ + "media/promo/velle/images/recipes/recipe_3-88f9c6df7cb6c7d99da2a9747dc63dd2.jpg";